module.exports = __webpack_public_path__ + "static/media/emojis2_03.be794d81.svg";